import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import DeleteConfirmForSelected from "../common/deleteConfirmForSelected";
// import { add3Dots } from "../../utils/queryString";
import {
  toastDelPermission,
  toastEditPermission,
} from "../../utils/toastPermission";
import {
  deleteSelectedGiveaway,
  getAllGiveAwayList,
} from "../../reducers/adminReducers";
const ListDatatable = ({
  id,
  myData,
  myClass,
  multiSelectOption,
  pagination,
  setActiveId,
  setOpen,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || [];
  const [data, setData] = useState();
  const [selectedBox, setSelectedBox] = useState([]);
  const [openDelPopup, setOpenDelPopup] = useState(false);
  const [selectedRows, setSelectedRows] = useState(true);
  useEffect(() => {
    setData(myData);
  }, [myData]);
  let delRole = role?.some((r) =>
    ["suUsers", "superAdmin", "delCategory"].includes(r),
  );
  let editRole = role?.some((r) =>
    ["suUsers", "superAdmin", "writeCategory"].includes(r),
  );

  const columnDefs = [
    {
      name: "Image",
      cell: (row) => <ProfileImage row={row} />,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Total Prize",
      selector: (row) => row.prize,
      sortable: true,
    },
    {
      name: "Winner Count",
      selector: (row) => row.winnerCount,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row.status || "",
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endTime).format("DD/MM/YYYY HH:mm"),
    },

    {
      name: "Action",
      cell: (row) => (
        <ActionButton
          row={row}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          role={role}
          delRole={delRole}
          editRole={editRole}
          handleView={handleView}
        />
      ),
    },
  ];

  const handleView = (id) => {
    setActiveId(id);
    history.push(`/giveaway-details?id=${id}`);
  };

  useEffect(() => {
    const check = delRole || editRole;
    if (!check) {
      columnDefs.pop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnDefs]);

  const handleEdit = (id) => {
    setActiveId(id);
    history.push(`/create-giveaway?id=${id}`);
  };
  const handleDelete = (id) => {
    setActiveId(id);
    setOpen(true);
  };
  const handleSelectCategory = (row) => {
    let selectedPro = [];
    if (!row.allSelected) {
      row?.selectedRows.forEach((el) => {
        selectedPro?.push(el?._id);
      });
      setSelectedBox(selectedPro);
      setSelectedRows(true);
    }
    if (row.allSelected) {
      row?.selectedRows.forEach((el) => {
        selectedPro?.push(el?._id);
      });
      setSelectedBox(selectedPro);
      setSelectedRows(true);
    }
  };
  const handleSelectedDelete = async (e, id) => {
    e.preventDefault();
    const res = await dispatch(deleteSelectedGiveaway(id));
    const { resultData } = res?.payload;
    if (resultData?.code === 200) {
      dispatch(getAllGiveAwayList());
      setOpenDelPopup(false);
      setSelectedRows(false);
    }
  };
  const onCloseModal = () => {
    setOpenDelPopup(false);
  };
  const selectDeleteOpen = (e) => {
    e.preventDefault();
    if (selectedBox.length > 0) {
      setOpenDelPopup(true);
    }
  };
  return (
    <div>
      <DeleteConfirmForSelected
        open={openDelPopup}
        handleSelectedDelete={handleSelectedDelete}
        onCloseModal={onCloseModal}
        id={selectedBox}
      />
      {role?.some((r) =>
        ["suUsers", "superAdmin", "delCategory"].includes(r),
      ) && (
        <div className="btn-popup pull-right">
          <span
            className="btn btn-secondary del-btn"
            onClick={selectDeleteOpen}>
            Delete
          </span>
        </div>
      )}
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
            selectableRows
            clearSelectedRows={selectedRows}
            onSelectedRowsChange={(e) => handleSelectCategory(e)}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ProfileImage = ({ row }) => {
  return (
    <div className="profile-image">
      <img src={row.image ? row.image : placeholder} alt="logo" />
    </div>
  );
};

const ActionButton = ({
  row,
  handleDelete,
  handleEdit,
  role,
  delRole,
  editRole,
  handleView,
}) => {
  return (
    <div className="action-btn">
      <span>
        <i
          onClick={() => handleView(row._id)}
          className="fa fa-eye"
          style={{
            width: 35,
            fontSize: 20,
            padding: 11,
            color: "#17a2b8",
            cursor: "pointer",
          }}></i>
      </span>
      {delRole && (
        <span>
          <i
            onClick={() =>
              delRole ? handleDelete(row._id) : toastDelPermission("category")
            }
            className="fa fa-trash"
            disabled="disabled"
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "#e4566e",
            }}></i>
        </span>
      )}

      {editRole && (
        <span>
          <i
            onClick={() =>
              editRole ? handleEdit(row._id) : toastEditPermission("category")
            }
            className="fa fa-pencil"
            disabled
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}></i>
        </span>
      )}
    </div>
  );
};

export default ListDatatable;
